import { CssBaseline, ThemeProvider as MuiThemeProvider, PaletteOptions } from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { createContext, useContext, useMemo } from 'react';
import { palettes, theme as baseTheme } from 'setup/theme';
import { useLocalStorage } from 'usehooks-ts';

const ThemeContext = createContext<ThemeState>({} as ThemeState);

export const useTheme = () => useContext(ThemeContext);

export function withTheme(WrappedComponent: any) {
    return function ThemeWrappedComponent(props: any) {
        return <ThemeContext.Consumer>{state => <WrappedComponent {...props} theme={state} />}</ThemeContext.Consumer>;
    };
}

export function ThemeProvider({ children }: ThemeProviderProps) {
    const [colorScheme, setColorScheme] = useLocalStorage<ThemeColorScheme>('theme.colorScheme', 'light');

    const theme = useMemo(() => {
        return createTheme({
            ...baseTheme,
            palette: {
                ...(baseTheme.palette as PaletteOptions),
                ...palettes[colorScheme],
                mode: colorScheme,
            },
        });
    }, [colorScheme]);

    const state = {
        colorScheme,
        darkMode: colorScheme === 'dark',
        setColorScheme,
    };

    return (
        <ThemeContext.Provider value={state}>
            <MuiThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </MuiThemeProvider>
        </ThemeContext.Provider>
    );
}
